import { useNavigate } from "react-router-dom";
import { EmailForwardingPage } from "@/components/EmailForwardingPage";

export function EmailForwardingSetupPage() {
  const navigate = useNavigate();
  return <EmailForwardingPage onBillClick={(id) => navigate(`/bills/${id}`)} />;
}
